import React from 'react';
import { Chip } from '@mui/material';
import './DraftLabel.scss';

export const DraftLabel = ({ draft }: { draft?: boolean }) =>
  draft ? <Chip className='draft-label' label='DRAFT' /> : null;
